import type {SupportedLocales} from '@/lib/locale/locale'
import type {MultiFullProduct, Product, RawProduct} from '@/models/productModel'
import {createQueryConfig, NO_REFETCH_OPTIONS} from '@/utils/query/query'

export default createQueryConfig({
  product: (retailer: RawProduct['retailer'], id: RawProduct['id'], locale: SupportedLocales) => ({
    key: ['product', retailer, id, locale] as const,
    data: {} as false | Product,
    options: {
      ...NO_REFETCH_OPTIONS,
      staleTime: 15 * 60 * 100, // 15 minutes
    },
  }),
  productDetails: (
    retailer: RawProduct['retailer'],
    id: RawProduct['id'],
    locale: SupportedLocales,
  ) => ({
    key: ['productDetails', retailer, id, locale] as const,
    data: {} as false | MultiFullProduct,
    options: {
      ...NO_REFETCH_OPTIONS,
      staleTime: 15 * 60 * 100, // 15 minutes
    },
  }),
})
